import { STATE_META, STATE_ORDER } from './tableStates';

export const TableLegend = ({ counts = {} }) => (
  <div className="flex flex-wrap gap-2" data-testid="table-legend">
    {STATE_ORDER.map((k) => {
      const m = STATE_META[k];
      const Icon = m.icon;
      return (
        <div key={k} data-testid={`legend-${k}`}
          className="flex items-center gap-1.5 px-3 py-1 rounded-full bg-card border border-border text-xs font-semibold">
          <span data-state-swatch className={`w-2.5 h-2.5 rounded-full ${m.blink ? 'table-blink' : ''}`}
            style={m.outline ? { border: `2px dashed ${m.color}` } : { background: m.color }} />
          <Icon className="w-3.5 h-3.5" style={{ color: m.color }} />
          {m.label}{k === 'reserved' && ' (<60 min)'}
          {counts[k] ? <span className="text-muted-foreground">· {counts[k]}</span> : null}
        </div>
      );
    })}
  </div>
);
